import { createQueryKeys } from '@lukemorales/query-key-factory';

export const userReviewsKeys = createQueryKeys('userReviews', {
  list: (uid: string, includeAllReviews: boolean) => ({
    uid,
    includeAllReviews,
  }),
  canFetchRecommendations: () => ['canFetchRecommendations'],
});
